import { api } from '@/api'

export type TrafficDetectorChartPoint = {
  d: string
  v: number
}

export type TrafficDetectorsChartsData = {
  type: number
  passengerVehicle?: TrafficDetectorChartPoint[]
  truckVehicle?: TrafficDetectorChartPoint[]
  unrecognizedVehicle?: TrafficDetectorChartPoint[]
  oppositeDirection?: TrafficDetectorChartPoint[]
  sameDirection?: TrafficDetectorChartPoint[]
  oppositeDirectionAverage?: TrafficDetectorChartPoint[]
  oppositeDirectionMax?: TrafficDetectorChartPoint[]
  oppositeDirectionMin?: TrafficDetectorChartPoint[]
  sameDirectionAverage?: TrafficDetectorChartPoint[]
  sameDirectionMax?: TrafficDetectorChartPoint[]
  sameDirectionMin?: TrafficDetectorChartPoint[]
}

export type TrafficDetectorsChartsRes = {
  success: boolean
  data: TrafficDetectorsChartsData
}

const trafficDetectorsChartsService = api.injectEndpoints({
  endpoints: (build) => ({
    postTrafficDetectorsCharts: build.mutation<
      TrafficDetectorsChartsRes,
      {
        deviceId: number
        categoryType: number
        startDate: string
        endDate: string
      }
    >({
      query: ({ deviceId, categoryType, startDate, endDate }) => ({
        url: '/charts/traffic-detectors',
        method: 'POST',
        body: {
          deviceId,
          startDate,
          endDate,
          categoryType,
        },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { usePostTrafficDetectorsChartsMutation } =
  trafficDetectorsChartsService
